goog.provide("shadow.js.shim.module$$mui$material$Backdrop");
goog.provide("module$shadow_js_shim_module$$mui$material$Backdrop");
shadow.js.shim.module$$mui$material$Backdrop = shadow.js.nativeProvides["@mui/material/Backdrop"] = shadow$bridge("@mui/material/Backdrop");
module$shadow_js_shim_module$$mui$material$Backdrop.default = shadow.js.shim.module$$mui$material$Backdrop;
